<script>
import Vue from 'vue';
import NavigationMenu from '../NavigationMenu/NavigationMenu.vue';
import TopMenu from '../TopMenu/TopMenu.vue';
import {mapState} from 'vuex';

export default Vue.extend({
    components: {
        NavigationMenu,
        TopMenu
    },
    computed: {
        ...mapState({
            navMinimized: state => state.nav.minimized
        })
    }
});
</script>
<template>
    <div id="dashboard-container" :class="{'dashboard-container--nav-minimized': navMinimized}" class="dashboard-container">
        <div class="dashboard-container__topbar">
            <top-menu/>
        </div>
        <div class="dashboard-container__menu">
            <navigation-menu/>
        </div>
        <div class="dashboard-container__page">
            <router-view/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardContainer/DashboardContainer.vue